import React, { useRef, useState } from "react";
import { Col, Form, Modal, Row, Select, Input, message } from "antd";
import { connect } from "dva";
import { ShipmentCancelReason, ShipmentStatus } from "@/utils/enum";
import { cancelShipmentReasons } from "@/utils/utils";

const handleCancel = (shipmentData, dispatch, cancelShipmentFormRef) => {
  cancelShipmentFormRef.current.validateFields().then(result => {
    const shipmentWasPostedStatus = shipmentData.status === ShipmentStatus.Posted;
    const shipmentId = shipmentData.id;
    dispatch({
      type: "shipmentDetails/cancelShipment",
      shipmentId,
      reason: result.reason,
      otherReason: result.otherReason,
      shipmentStatus: shipmentData.status,
    }).then(res => {
      if (res.error) {
        message.error("Could not cancel shipment. Please contact Autosled support.");
      } else {
        dispatch({
          type: "shipmentDetails/toggleCancelModalVisible",
          payload: false,
        }).then(() => {
          if (shipmentWasPostedStatus) {
            Modal.success({
              content: "Your shipment has been successfully cancelled.",
              style: { fontWeight: "bold" },
              width: "25%",
            });
          } else {
            Modal.success({
              content: "Your cancellation request has been sent to Autosled. Please wait for review.",
              style: { fontWeight: "bold" },
              width: "35%",
            });
          }
        });
        cancelShipmentFormRef?.current?.resetFields();
      }
    });
  });
};

const CancelShipmentModal = props => {
  const { shipmentData, cancelModalVisible, loadingCancelShipment, dispatch } = props;

  const { Option } = Select;
  const { TextArea } = Input;

  const cancelShipmentFormRef = useRef();
  const [showOtherTextBox, setShowOtherTextBox] = useState(false);
  const isRequestingCancellation = shipmentData.status > ShipmentStatus.Posted;

  return (
    <Modal
      title={isRequestingCancellation ? "Request Cancel" : "Cancel Shipment"}
      open={cancelModalVisible}
      onOk={() => {
        handleCancel(shipmentData, dispatch, cancelShipmentFormRef);
      }}
      onCancel={() => {
        dispatch({
          type: "shipmentDetails/toggleCancelModalVisible",
          payload: false,
        });
        cancelShipmentFormRef?.current?.resetFields();
      }}
      confirmLoading={loadingCancelShipment}
    >
      <Form layout="vertical" ref={cancelShipmentFormRef}>
        <Row gutter={16}>
          <Col lg={24}>
            <p>
              Please enter reason for cancelling shipment. <br />
              {shipmentData.status === ShipmentStatus.Completed &&
                "NOTE: Cancellations to Assigned shipments are subject to review."}
            </p>
            <Form.Item name="reason" label="Reason" rules={[{ required: true }]}>
              <Select onChange={value => setShowOtherTextBox(value === ShipmentCancelReason.Other)}>
                {cancelShipmentReasons.map(reason => (
                  <Option key={reason.value} value={reason.value}>
                    {reason.title}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            {showOtherTextBox && (
              <Form.Item name="otherReason" label="Other Reason" rules={[{ required: true }]}>
                <TextArea rows={4} />
              </Form.Item>
            )}
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default connect(({ shipmentDetails, loading }) => ({
  shipmentData: shipmentDetails.data,
  cancelModalVisible: shipmentDetails.cancelModalVisible,
  loadingCancelShipment: loading.effects["shipmentDetails/cancelShipment"],
}))(CancelShipmentModal);
